import { PaginationData } from '@modules/HappinessModule/interfaces/PaginationData';
import httpNodeClient from '@shared/api/httpNodeClient';
import { SignInActivitiesPageData } from '../pages/SignInActivitiesPage/redux/types';

export const fetchSignInActivities = (paginationData: PaginationData): Promise<{ data: SignInActivitiesPageData }> =>
  httpNodeClient
    .get<{ data: SignInActivitiesPageData }>('sign-in-activities/me', { params: paginationData })
    .then(({ data }) => data);
